import styled from 'styled-components';

export const Container = styled.div`
  border-radius: 2px;
  background-color: ${({ theme }) => theme.palette.NL0};
  box-shadow: 0px 10px 20px 0px rgba(58, 58, 58, 0.1);
  padding: 40px 40px 0 40px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  overflow: hidden;
  border-radius: 8px;

  & .swiper {
    width: 100%;
    padding-bottom: 68px;
  }

  & .swiper-pagination {
    bottom: 20px;
  }

  & .swiper-pagination-bullet {
    width: 12px;
    height: 12px;
    border-radius: 6px;
    border: 1px solid ${({ theme }) => theme.palette.NL0};
    background-color: ${({ theme }) => theme.palette.D400};
    background: ${({ theme }) => theme.palette.D400};
    opacity: 1;
  }

  & .swiper-pagination-bullet-active {
    width: 40px;
    height: 12px;
    border-radius: 7px;
    border: 1px solid ${({ theme }) => theme.palette.NL0};
    background-color: ${({ theme }) => theme.palette.BR300};
  }
`;

export const SwiperWrapper = styled.div`
  position: relative;
`;

export const SingleItemWrapper = styled.div`
  padding-bottom: 40px;
`;

export const CustomSwipeButton = styled.div<{ left?: boolean }>`
  width: 36px;
  height: 36px;
  background-color: ${({ theme }) => theme.palette.D400};
  opacity: 0.5;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 4;
  position: absolute;
  top: 50%;
  ${({ left }) => (left ? 'left: -18px;' : 'right: -18px;')}
  transform: translateY(-50% );

  &.swiper-button-next::after {
    display: none;
  }
  &.swiper-button-prev::after {
    display: none;
  }
`;
